module.exports = __webpack_public_path__ + "f244a18.webp";